import React, { useState } from "react";
import Image from "next/image";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import GlobalForm from "@/components/forms/GlobalForm";
import useModalScrollLock from "@/hooks/useModalScrollLock";

const UspVisitRoadmapMobile = () => {
  const [isFormModelOpen, setIsFormModelOpen] = useState<boolean>(false);

  const handleFormModelOpen = () => {
    setIsFormModelOpen(true);
  };

  const handleFormModelClose = () => {
    setIsFormModelOpen(false);
  };

  useModalScrollLock(isFormModelOpen, {
    restoreScrollPosition: true,
    preventTouchScroll: true,
  });

  return (
    <>
      <div className="w-full bg-[#061A2F] relative bg-cover bg-no-repeat overflow-hidden">
        <div className="flex justify-center ml-3 pt-6">
          <Image
            src="/usp/roadmapMobile.png"
            alt="Special Offer"
            className="w-full px-3"
            width={390}
            height={328}
            priority
          />
        </div>
        <div className="flex flex-row justify-between px-5 pt-2 pb-4">
          <div className="text-left">
            <p className="text-[#D8D8D8] text-[14px]">
              Mar 28 | Saturday |<br /> 3 PM IST{" "}
            </p>
          </div>

          <div className="flex justify-center ml-6">
            <div className="grp_btn flex items-center justify-end relative z-[9] w-[190px]">
              <Image
                priority
                src="/arrow_new.png"
                alt="arrow image"
                className="new_arrow"
                width={39}
                height={39}
              />
              <p
                className="new__discover_btn text-[12px] inline-block !rounded-[14px_14px_14px_0px] font-bold"
                onClick={handleFormModelOpen}
              >
                Register Now
              </p>
            </div>
          </div>
        </div>
      </div>
      {isFormModelOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div
            className="rounded-2xl shadow-lg relative h-[auto] mx-auto border border-white p-4"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <button
              onClick={handleFormModelClose}
              className="text-white text-lg absolute right-0 top-0 cursor-pointer"
            >
              ✕
            </button>
            <div className="pt-3">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                alt="star group"
                width={34}
                height={38}
                className="absolute top-6 left-[-10px]"
              />
              <GlobalForm
                course="live webinar"
                courseId={3}
                formHeading={
                  FormHeading.JOIN_THE_WEBINAR_AND_MAKE_THE_BIG_DECISION
                }
                formType="model"
                submitButtonName="Register Now"
                successMessage={SuccessMessageType.LIVE_WEBINAR}
                darkBackground={true}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UspVisitRoadmapMobile;
